module.exports = __webpack_public_path__ + "img/labelsNumbersOrderOff.ba8fd61b.svg";